import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { Toaster } from "react-hot-toast";
import { Provider as WrapBalancerProvider } from "@hightouchio/react-wrap-balancer";
import { theme } from "./theme";
export function ThemeProvider({ children }) {
    return (React.createElement(ChakraProvider, { theme: theme },
        React.createElement(WrapBalancerProvider, null,
            children,
            React.createElement(Toaster, null))));
}
